"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.voice-agent.disabled': 'La función de agente de voz no está disponible en su plan actual.',
};
